import React from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import ContainerWide from "../components/ContainerWide";
import { VectorBackground } from "../components/VectorBackground";

const isHtmlFile = (src) => /\.html?(?:[?#].*)?$/i.test(src || "");

const LottieAsset = ({ src, className, aspectRatio, title }) => {
    if (isHtmlFile(src)) {
        return (
            <iframe
                src={src}
                title={title}
                className={`${className} lottie__iframe`}
                style={{ aspectRatio }}
                loading="lazy"
                scrolling="no"
                sandbox="allow-scripts allow-same-origin"
            />
        );
    }

    return (
        <DotLottieReact
            src={src}
            loop
            autoplay
            className={className}
            style={{ aspectRatio }}
            layout={{ fit: "cover" }}
        />
    );
};

const Lottie = ({
    header,
    description,
    lottieSrc,
    lottieSrcMobile,
    bottomText,
    size,
    slug,
    variant,
}) => {
    const desktopSrc = lottieSrc?.localFile?.publicURL;
    const mobileSrc = lottieSrcMobile?.localFile?.publicURL;
    const isLight = variant === "light";

    return (
        <ContainerWide
            className={`lottie__container${
                isLight ? " lottie__container--light" : ""
            }`}
            id={slug || undefined}
        >
            {!isLight && <VectorBackground gradient strokeOpacity={0.07} />}
            <div className="lottie__visual">
                {(header || description) && (
                    <div className="lottie__intro">
                        {header && (
                            <h2
                                className="lottie__header"
                                dangerouslySetInnerHTML={{ __html: header }}
                            />
                        )}
                        {description && (
                            <div
                                className="lottie__description"
                                dangerouslySetInnerHTML={{
                                    __html: description,
                                }}
                            />
                        )}
                    </div>
                )}
                {desktopSrc && (
                    <LottieAsset
                        src={desktopSrc}
                        className="lottie__animation lottie__animation--desktop"
                        aspectRatio="1280/520"
                        title={
                            header
                                ? header.replace(/<[^>]*>?/gm, "")
                                : "Animation"
                        }
                    />
                )}
                {mobileSrc && (
                    <LottieAsset
                        src={mobileSrc}
                        className="lottie__animation lottie__animation--mobile"
                        aspectRatio="390/600"
                        title={
                            header
                                ? header.replace(/<[^>]*>?/gm, "")
                                : "Animation"
                        }
                    />
                )}
            </div>
            {bottomText && (
                <p
                    className="lottie__bottom-text"
                    dangerouslySetInnerHTML={{ __html: bottomText }}
                />
            )}
        </ContainerWide>
    );
};

export default Lottie;
